import fetchWithAuth, { get, post, put } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class AlertService {
  static async getAll(page, size, filters = {}, sortConfig = {}) {
    const companyId = getCompanyId();
    const queryParams = buildCrudQueryParams({
      page,
      size,
      filters,
      sortConfig,
      companyId,
      sortMode: 'split',
    });

    return await get(`/alert?${queryParams.toString()}`);
  }

  static async getUnreadCount() {
    const companyId = getCompanyId();
    if (!companyId) return 0;
    return await get(`/alert/unread-count?companyId=${encodeURIComponent(companyId)}`);
  }

  static async markAsRead(alertId) {
    return await put(`/alert/read/${alertId}`, {});
  }

  static async getRecipientsForCompany(companyId) {
    if (!companyId) return [];
    return await get(`/people/alert-recipients?companyId=${encodeURIComponent(companyId)}`);
  }

  static async createBulk({ companyId, recipientPeopleIds, title, text, sendEmail }) {
    return await post('/alert/bulk', { companyId, recipientPeopleIds, title, text, sendEmail: !!sendEmail });
  }

  static async createBulkWithFiles({ companyId, recipientPeopleIds, title, text, sendEmail, files = [] }) {
    const fd = new FormData();
    fd.append('companyId', String(companyId));
    (recipientPeopleIds || []).forEach((id) => fd.append('recipientPeopleIds', String(id)));
    fd.append('title', title);
    fd.append('text', text);
    fd.append('sendEmail', String(!!sendEmail));
    (files || []).forEach((file) => fd.append('files', file));
    return await post('/alert/bulk', fd);
  }

  static async getAttachments(alertId) {
    return await get(`/alert/${alertId}/attachments`);
  }

  static async getRecipientsStatus(alertId) {
    return await get(`/alert/${alertId}/recipients-status`);
  }

  static async downloadAttachment(attachmentId) {
    const response = await fetchWithAuth(`/alert/attachment/${attachmentId}/download`, { method: 'GET' });
    if (!response.ok) {
      const text = await response.text().catch(() => '');
      const clean = (text || '').trim();
      const suffix = clean ? `: ${clean}` : '';
      throw new Error(`Download failed (${response.status} ${response.statusText || ''})${suffix}`);
    }
    const blob = await response.blob();
    const cd = response.headers.get('content-disposition') || '';
    const matchUtf8 = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    const matchPlain = cd.match(/filename="([^"]+)"/i);
    const raw = matchUtf8 ? matchUtf8[1] : (matchPlain ? matchPlain[1] : '');
    const filename = raw ? decodeURIComponent(raw) : '';
    return { blob, filename };
  }

  // Útil para disparar alertas desde UI/admin si lo necesitas
  static async create(alertCreateRq) {
    return await post('/alert', alertCreateRq);
  }
}

export default AlertService;

